import classNames from 'classnames';
import * as yup from "yup";
import { Formik } from 'formik';
import moment from 'moment';
import { errorMessages } from '../../constants/error.messages';
import { DateField } from '../common/form-fields/DateField';
import { Popup } from '../controls';
import { DateTimeStamp } from '../../types/primitives/DateTimeStamp';
import { constants } from '../../constants';

export interface TradeSubmitForm {
    tradeDate: DateTimeStamp;
}

const tradedConfirmValidationSchema = yup.lazy(() => yup.object().shape({
    tradeDate: yup
        .date()
        .test('isValidDateFormat', errorMessages.invalidValue, (value) => moment(value, 'MM/DD/YYYY', true).isValid())
        .typeError(errorMessages.invalidValue)
        .max(moment.utc().startOf('day').format(constants.dateTimeFormatUtc), errorMessages.dateShouldBeInPast)
        .required()
}));

interface TradedConfirmPopupProps {
    ticker: string;
    onTradedChange: (tradeDate: DateTimeStamp) => void;
    onClose: () => void;
}

export const TradedConfirmPopup = ({ ticker, onTradedChange, onClose }: TradedConfirmPopupProps) => {
    const handleConfirmTraded = ({ tradeDate }: TradeSubmitForm) => {
        onTradedChange(tradeDate);
        onClose();
    }

    return (
        <Popup renderInBody={true} modalClass="modal-confirmation" title="Confirmation" onClose={onClose}>
            <Formik
                initialValues={{ tradeDate: moment.utc().startOf('day').format(constants.dateTimeFormatUtc) }}
                validationSchema={tradedConfirmValidationSchema}
                onSubmit={handleConfirmTraded}
            >
                {({ submitForm, isValid }) => (
                    <>
                        <div className="modal-body">
                            <p className="status-message alert">
                                <i className="icon icon-warning" />
                                <span className="status-message-cnt">
                                    Would you like to mark security with {ticker} as traded? This operation is irreversible.
                                </span>
                            </p>
                            <DateField
                                label="Trade date"
                                name="tradeDate"
                                maximumDate={new Date()}
                                dateFormat="MM/DD/YYYY"
                                required
                            />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
                            <button
                                disabled={!isValid}
                                className={classNames('btn', 'btn-main')}
                                onClick={submitForm}
                            >
                                Confirm
                            </button>
                        </div>
                    </>
                )}
            </Formik>
        </Popup >
    );
}
